<template>
  <qm-card class="qm-card-form">
    <header class="qm-card-header">
      <div class="header-title">
        {{ title }}
      </div>
      <div v-if="description" class="header-description">
        {{ description }}
      </div>
    </header>
    <main class="qm-card-body">
      <div class="body-left">
        <slot />
      </div>
      <div class="body-right" />
    </main>
    <footer ref="footer" class="qm-card-footer">
      <slot name="footer" />
    </footer>
  </qm-card>
</template>

<script>
import QmCard from './qm-card'

export default {
  name: 'QmFormCard',
  components: {
    QmCard,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {},
}
</script>

<style></style>
